import React, { useEffect, useState } from "react";
import { useParams, Link } from "react-router-dom";
import { Box, Button, IconButton } from "@mui/material";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import ArrowForwardIosIcon from "@mui/icons-material/ArrowForwardIos";
import ArrowBackIosNewIcon from "@mui/icons-material/ArrowBackIosNew";
import threeFold01 from "../../assets/design/threeFold/threeFold01.jpg";
import threeFold02 from "../../assets/design/threeFold/threeFold02.jpg";
import mooncake01 from "../../assets/design/mooncake/mooncake01.jpg";
import mooncake02 from "../../assets/design/mooncake/mooncake02.jpg";
import kemooMain from "../../assets/design/kemoo/kemooMain.jpg";
import kemoo01 from "../../assets/design/kemoo/kemoo01.jpg";
import kemoo02 from "../../assets/design/kemoo/kemoo02.jpg";
import kemoo03 from "../../assets/design/kemoo/kemoo03.jpg";
import kemoo04 from "../../assets/design/kemoo/kemoo04.jpg";
import kemoo05 from "../../assets/design/kemoo/kemoo05.jpg";
import kemoo06 from "../../assets/design/kemoo/kemoo06.jpg";
import kemoo07 from "../../assets/design/kemoo/kemoo07.jpg";
import logo01 from "../../assets/design/logoDesign/logo01.jpg";
import logo02 from "../../assets/design/logoDesign/logo02.jpg";
import egg from "../../assets/design/egg/egg.jpg";

const collections = [
    { id: 1, images: [kemooMain, kemoo01, kemoo02, kemoo03, kemoo04, kemoo05, kemoo06, kemoo07], title: '可沐蔬果', intro: 'description' },
    { id: 2, images: [threeFold01, threeFold02], title: '三折頁設計', intro: 'description' },
    { id: 3, images: [mooncake01, mooncake02], title: '月餅禮盒', intro: 'description' },
    { id: 4, images: [logo01, logo02], title: 'am logo design', intro: 'description' },
    { id: 5, images: [egg], title: '皮蛋', intro: 'description' },
];


const DesignDetail = () => {
    const { id } = useParams();
    const collection = collections.find((col) => col.id === parseInt(id));

    if (!collection) return <Box>Collection not found</Box>;

    return (

        <Box
            sx={{
                marginTop: "40px",
                px: { xs: 2, md: 6 }, // responsive horizontal padding
                py: { xs: 8, md: 12 }, // responsive vertical padding
                minHeight: "calc(100vh - 140px)",
                position: "relative",
                maxWidth: "1200px",
                marginLeft: "auto",
                marginRight: "auto",
                overflowX: "hidden", // ensure no X scrollbar ever
            }}
        >


            {/* Main Content */}
            <Box
                sx={{
                    display: "flex",
                    flexDirection: { xs: "column", md: "row" },
                    gap: 6,
                    alignItems: "flex-start",
                }}
            >
                {/* Left: All Images stacked vertically */}
                <Box
                    sx={{
                        flex: "1 1 60%",
                        maxWidth: { xs: "100%", md: "600px" }, // reduced from 700px
                        display: "flex",
                        flexDirection: "column",
                        gap: 4,
                        overflowY: "visible",
                    }}
                >
                    {collection.images.map((img, idx) => (
                        <Box
                            key={idx}
                            component="img"
                            src={img}
                            alt={`${collection.title} image ${idx + 1}`}
                            className="fade-up"
                            sx={{
                                width: "100%",
                                borderRadius: 2,
                                objectFit: "contain",
                                userSelect: "none",
                                boxShadow: "0 4px 8px rgba(0,0,0,0.1)",
                            }}
                            style={{
                                animationDelay: `${idx * 0.1}s`, // staggered delay
                            }}
                            draggable={false}
                        />
                    ))}


                </Box>

                {/* Right: Title + intro */}
                <Box
                    sx={{
                        flex: "1 1 35%",
                        maxWidth: { xs: "100%", md: "400px" },
                        display: "flex",
                        flexDirection: "column",
                        justifyContent: "flex-start",
                        paddingTop: { xs: 4, md: 0 },
                    }}
                >
                    <Box
                        sx={{
                            fontSize: { xs: "1.3rem", md: "1.8rem" },
                            fontWeight: "bold",
                            color: "#333",
                            marginBottom: 2,
                            fontFamily: "'Poppins', sans-serif",
                        }}
                    >
                        {collection.title}
                    </Box>
                    <Box
                        sx={{
                            fontSize: "0.8rem",
                            lineHeight: 1.6,
                            color: "#555",
                            whiteSpace: "pre-line",
                            fontFamily: "'Noto Sans TC', sans-serif",
                        }}
                    >
                        {collection.intro}
                    </Box>
                </Box>
            </Box>
            {/* Navigation Footer Row */}
            <Box
                sx={{
                    width: "100%",
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                    borderTop: "1px solid #ddd",
                    marginTop: 8,
                    paddingTop: 4,
                    paddingBottom: 4,
                    fontFamily: "'Poppins', sans-serif",
                    fontSize: "1rem",
                    fontWeight: 500,
                    color: "#444",
                    flexWrap: "wrap",
                    gap: 2,
                }}
            >
                {/* Back to Work */}
                <Link to="/design" style={{ textDecoration: "none", color: "#444" }}>
                    Back to Design
                </Link>

                {/* Prev / Next */}
                <Box>
                    <span style={{ color: parseInt(id) === 1 ? "#ccc" : "#444" }}>
                        {parseInt(id) === 1 ? "prev" : (
                            <Link
                                to={`/design-detail/${parseInt(id) - 1}`}
                                style={{ textDecoration: "none", color: "#444" }}
                            >
                                prev
                            </Link>
                        )}
                    </span>{" "}
                    /{" "}
                    <span style={{ color: parseInt(id) === collections.length ? "#ccc" : "#444" }}>
                        {parseInt(id) === collections.length ? "next" : (
                            <Link
                                to={`/design-detail/${parseInt(id) + 1}`}
                                style={{ textDecoration: "none", color: "#444" }}
                            >
                                next
                            </Link>
                        )}
                    </span>
                </Box>
            </Box>

        </Box>
    );
};

export default DesignDetail;
